import { Box, Link, Typography } from '@mui/material';
import { MemberChangeLog } from 'src/modules/member/models/memberChangeLog';
import { DateHelper } from 'src/shared/helpers/dateHelper';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

type DashboardLogItemProps = {
  item: MemberChangeLog;
};

const getActionColor = (action: string | undefined): string => {
  if (!action) return '#9e9e9e';
  const lower = action.toLowerCase();
  if (lower.includes('ny ') || lower.includes('aktiverad') || lower.includes('återinträdd') || lower.includes('återregistrerad')) return '#00af83';
  if (lower.includes('intresse')) return '#ff9800';
  if (lower.includes('borttagen') || lower.includes('avregistrerad') || lower.includes('avliden')) return '#f44336';
  if (lower.includes('frånflyttad') || lower.includes('tillflyttad')) return '#ff9800';
  return '#2196f3';
};

export const DashboardLogItem = (props: DashboardLogItemProps) => {
  const { item } = props;

  return (
    <Box sx={{ display: 'flex', gap: 1.5, py: 1.25, borderTop: (thm) => `1px solid ${thm.palette.divider}` }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', pt: 0.75 }}>
        <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: getActionColor(item.action), flexShrink: 0 }} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography variant='body2' sx={{ fontWeight: 500 }}>
            {item.action}
          </Typography>
          <Typography variant='caption' color='text.secondary' sx={{ ml: 1, whiteSpace: 'nowrap' }}>
            {DateHelper.getTime(item.date)}
          </Typography>
        </Box>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Link variant='body2' href={`${RoutesEnum.MemberDetails}/${item.member_id}`} underline='none'>
            {`${item.memberFirstName} ${item.memberLastName}`}
          </Link>
          {item.signature && (
            <Typography variant='caption' color='text.secondary' sx={{ ml: 1, whiteSpace: 'nowrap' }}>
              {item.signature}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};
